import type { ReactNode } from "react";
import { Platform } from "react-native";
import { Anchor, styled } from "tamagui";

/**
 * Styled anchor that is visually hidden until keyboard-focused.
 * Based on Tamagui's Anchor (SizableText + href) so text children are valid.
 */
const SkipAnchor = styled(Anchor, {
  name: "SkipAnchor",
  position: "absolute",
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  whiteSpace: "nowrap",
  borderWidth: 0,
  focusVisibleStyle: {
    position: "fixed",
    width: "auto",
    height: "auto",
    paddingVertical: "$100",
    paddingHorizontal: "$200",
    margin: 0,
    overflow: "visible",
    whiteSpace: "normal",
    zIndex: 999999,
    top: "$100",
    left: "$100",
    backgroundColor: "$textPrimary",
    color: "$backgroundFill",
    borderRadius: "$50",
    fontSize: "$sm",
    textDecorationLine: "none",
  },
});

/**
 * Skip-to-main-content link (WCAG 2.4.1 Bypass Blocks).
 * Visually hidden until focused, then rendered as a fixed pill at top-left.
 */
export function SkipToLink({
  href = "#main",
  children = "Skip to main content",
}: {
  href?: string;
  children?: ReactNode;
}) {
  if (Platform.OS !== "web") return null;

  return <SkipAnchor href={href}>{children}</SkipAnchor>;
}
